// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"61250bb2","496":"159e0e0c","789":"feeb788c","841":"e30a9972","908":"163b95fe","955":"91958686"}[chunkId] + ".css";
};